import { Deserializable } from '../deserializable';
import { ValidationErrors } from '../validation/validation-errors';

export class EntityResponseDto<T> implements Deserializable {
  public Entity: T;
  public ValidationErrors: ValidationErrors;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.ValidationErrors = new ValidationErrors(input.ValidationErrors);

    return this;
  }
}
